import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CartCameras from "../cartCameras/cartCameras";
import CartCamerasCarousel from "../cartCameras/CartCamerasCarousel";

const CartCameraModal = ({ open, onClose, cartId, isPhoneSize }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",        // ← makes the close button anchor
          bgcolor: "#fff",
          borderRadius: 2,
          p: 2,
          width: isPhoneSize ? "90vw" : "auto",
          maxWidth: isPhoneSize ? 600 : "none",
        }}
      >
        {/* close icon */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 10,
            color: "var(--grey)",
          }}
          size="large">
          <CloseIcon />
        </IconButton>

        {/* modal body */}
        {isPhoneSize ? (
          <CartCamerasCarousel cartId={cartId} />
        ) : (
          <CartCameras cartId={cartId} />
        )}
      </Box>
    </Modal>
  );
};

export default CartCameraModal;
